import React, { useContext, useMemo, useState } from 'react'
import styled from 'styled-components'
import { Modal, ModalProps } from 'vvs-uikit'
import { useKeyPressEvent } from 'react-use'
import { useTranslation } from 'contexts/Localization'
import { BoostFarmModalStep as Step } from 'views/xVvs/types'
import xVvsContext from 'views/xVvs/context'
import { SelectBoostFarmStep } from './SelectBoostFarmStep'
import ConfirmStep from './ConfirmStep'

const StyledModal = styled(Modal)<ModalProps>`
  border: none;
  ${({ theme }) => theme.mediaQueries.sm} {
    min-width: 520px;
  }
`

interface BoostFarmSelectModalProps {
  onDismiss?: () => void
}

const BoostFarmSelectModal: React.FC<BoostFarmSelectModalProps> = ({ onDismiss }) => {
  const { t } = useTranslation()

  const [step, setStep] = useState(Step.SELECT_BOOST_FARM)

  const { setSelectedBoostFarms } = useContext(xVvsContext)

  const title = useMemo(() => {
    if (step === Step.SELECT_BOOST_FARM) {
      return t('Boost Your Selected Farms')
    }
    if (step === Step.CONFIRM_BOOST) {
      return t('Confirm Boost')
    }
    return ''
  }, [step, t])

  const handleDismiss = () => {
    setSelectedBoostFarms([])
    onDismiss()
  }

  useKeyPressEvent('Escape', () => {
    handleDismiss()
  })

  return (
    <StyledModal
      title={title}
      bodyPadding="0"
      onDismiss={handleDismiss}
      onBack={
        step > 0
          ? () => {
              setStep(Step.SELECT_BOOST_FARM)
            }
          : undefined
      }
    >
      {step === Step.SELECT_BOOST_FARM && <SelectBoostFarmStep setStep={setStep} />}
      {step === Step.CONFIRM_BOOST && <ConfirmStep onDismiss={handleDismiss} />}
    </StyledModal>
  )
}

export default BoostFarmSelectModal
